<template>
  <div id="intro_box" class="bg-inf" v-if="schedule.length > 0">
    <!--  -->
    <div id="nav_fixed" v-if="tour" class="d-none bg-info">
      <b-navbar class="fix_nav">
        <b-container>
          <!-- 價格 -->
          <b-nav-item href="#price_part" :class="{ active: activeSection === 'price_part' }"
            v-if="tour.price_img.length > 0 || tour.available_date[0].dates[0] !== ''">
            {{ $t('tourPrice') }}
          </b-nav-item>
          <!-- 出團狀況 -->
          <b-nav-item href="#departure_part" :class="{ active: activeSection === 'departure_part' }">
            {{ $t('tourDeparture') }}
          </b-nav-item>
          <!-- 航班資訊-->
          <b-nav-item href="#flight" v-if="tour.flight[0].airline">
            {{ $t('tourFlight') }}
          </b-nav-item>
          <!-- 行程 -->
          <b-nav-item href="#intro_part" :class="{ active: activeSection === 'intro_part' }">
            {{ $t('tourDescription') }}
          </b-nav-item>

          <!-- 注意事項 -->
          <!-- v-if="tour.noticeSelect[0]!==''" -->
          <b-nav-item href="#notice1" v-if="tour.noticeSelect[0]">
            {{ $t('notice1') }}
          </b-nav-item>
          <b-nav-item href="#notice2" v-if="tour.language !== 'en' && tour.noticeSelect[1]">
            {{ $t('notice2') }}
          </b-nav-item>
          <b-nav-item href="#notice3" v-if="tour.language !== 'en' && tour.noticeSelect[2]">
            {{ $t('notice3') }}
          </b-nav-item>
          <b-nav-item href="#notice4" v-if="tour.language !== 'en' && tour.noticeSelect[3]">
            {{ $t('notice4') }}
          </b-nav-item>
        </b-container>
      </b-navbar>
    </div>

    <div class="container">
      <!-- 版單 -->
      <div class="section my-4 d-non" id="quotaion_part"
        v-if="tour.quotation[0] && tour.quotation[0].quotationsFields[0].key">
        <h6 class="nav_title mt-4">行程報價</h6>
        <div v-for="quotaion in tour.quotation" :key=quotaion.id>
          <!-- 版單電腦版 -->
          <div v-if="!showScrollHint">
            <b-table outlined bordered small class="completeTable" :fields="quotaion.quotationsFields"
              :items="quotaion.tourQuotation">
              <template #cell(order1)="data">
                <a :href="data.item.id" target="_blank">{{ data.item.order1 }}</a>
              </template>
            </b-table>
            <div class="px-2" v-if="quotaion.ps.length > 0">
              <b>備註</b>
              <div class="white_space_pre">{{ quotaion.ps }}</div>
            </div>
          </div>
          <!-- 版單手機版 -->
          <div v-else>
            <b-card class="my-2" v-for="(item, index) in quotaion.tourQuotation" :key="index">
              <div v-for="(field, findex) in quotaion.quotationsFields" :key="findex">
                <b-badge class="mr-2" :variant="checkBadgeColor(quotaion.quotationsFields, findex)">{{ field.label
                }}</b-badge>{{
                }}
                <router-link :to="'/tour/' + item.id" target="_blank" v-if="findex === 0"><span>{{ item[field.key]
                }}</span></router-link>
                <span v-else>{{ item[field.key] }}</span>
              </div>
            </b-card>
            <div class="px-2 mb-5" v-if="quotaion.ps">
              <b>備註</b>
              <div class="white_space_pre">{{ quotaion.ps }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 出團狀況 $store.getters.loginRole === 'staff' 判斷是否是內部人 -->
      <div class="section my-4 d-non" id="departure_part"
        v-if="registration.data && registration.data[0].dynamicFields[0]">
        <h6 class="nav_title mt-4">出團狀況</h6>
        <div v-for="(registrItems, index) in registration.data" :key=index>
          <!-- 出團狀況電腦版 -->
          <div v-if="!showScrollHint">
            <b-table outlined bordered small class="completeTable" :fields="formattedFields(registrItems.fields)"
              :items="registrItems.dynamicFields">
              <!-- <template #cell(order1)="data">
                <a :href="data.item.id" target="_blank">{{ data.item.order1 }}</a>
              </template> -->
            </b-table>
            <div class="px-2" v-if="registration.ps">
              <b>備註</b>
              <div class="white_space_pre">{{ registration.ps }}</div>
            </div>
          </div>
          <!-- 出團狀況手機版 -->
          <div v-else>
            <b-card class="my-2" v-for="(item, index) in registrItems.dynamicFields" :key="index">
              <div v-for="(field, findex) in registrItems.fields" :key="findex">
                <b-badge class="mr-2" :variant="checkBadgeColor(field, findex)">{{ field.label }}</b-badge>{{ }}
                <span>
                  <span v-for="(value, key) in item" :key="key">
                    <span v-if="String(key).startsWith('order') && field.keyName === key">
                      {{ value }}<br>
                    </span>
                  </span>
                </span>
              </div>
            </b-card>
            <div class="px-2 mb-5" v-if="registration.ps">
              <b>備註</b>
              <div class="white_space_pre">{{ registration.ps }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 價格 x -->
      <div id="price_part" ref="price_part" class="mb-3 section"
        v-if="tour.price_img.length > 0 || tour.available_date[0].dates[0] !== ''">
        <div>
          <h6 class="nav_title mt-5">{{ $t('tourPrice') }}</h6>
        </div>
        <!-- 有填寫價格 -->
        <!-- <div v-if="tour.available_date[0].dates[0]!==''">
          <div class="d-flex flex-wrap price_box">
            <v-calendar
              v-if="tour.available_date[0].dates[0]!==''"
              class="noHover"
              :first-day-of-week="2"
              :attributes='tour.available_date'
              :masks="{ title: 'YYYY MMM' }"
              >
            </v-calendar>
            <div class="mx-1 mx-md-4 mt-3">
              <div class="normal_price"
                v-if="tour.normalPrice.child || tour.normalPrice.adult">
                <div>
                  <span class="mark"></span>
                  <strong>平日：</strong>
                </div>
                <span v-if="tour.normalPrice.adult">成人 NTD.</span>
                <span>{{tour.normalPrice.adult}}</span>
                <span v-if="tour.normalPrice.adult && tour.normalPrice.child"> /</span>
                <span v-if="tour.normalPrice.child"> 兒童 NTD.</span>
                <span>{{tour.normalPrice.child}}</span>
              </div>
              <div class="holiday_price"
                v-if="tour.holidayPrice.child || tour.holidayPrice.adult">
                <div class="mt-2">
                  <span class="mark"></span>
                  <strong>假日：</strong>
                </div>
                <span v-if="tour.holidayPrice.adult">成人 NTD.</span>
                <span>{{tour.holidayPrice.adult}}</span>
                <span v-if="tour.holidayPrice.adult && tour.holidayPrice.child"> /</span>
                <span v-if="tour.holidayPrice.child"> 兒童 NTD.</span>
                <span>{{ tour.holidayPrice.child }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- 有上傳價格圖片 -->
        <img v-if="tour.price_img.length > 0"
          :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/' + tour.price_img[0].filename + '.jpg'">
        <!-- <div v-if="tour.category!=='國內旅遊'" class="mt-3">(行程及報價僅供參考，因目前航班及飯店、球場、餐廳等都在漲價浮動中。實際以確定完日期人數內容後的價錢為主)</div> -->
      </div>

      <!-- 航班 -->
      <div id="flight" class="section" v-if="tour.flight[0].airline">
        <h6 class="nav_title">{{ $t('tourFlight') }}</h6>
        <div v-if="showScrollHint">請左右滑動以查看完整表格</div>
        <b-table outlined :fields='flightFields' ref="flight" :items="tour.flight" class="completeTable"></b-table>
      </div>

      <div id="intro_part" class="section" ref="intro_part">
        <h6 class="nav_title">
          {{ $t('tourDescription') }}
        </h6>
        <!-- 第X天框框 -->
        <b-row v-for="(day, index) in schedule" :key="index" class="mb-4 day_box">
          <b-col class="day_title" cols="12" v-if="tour.days > 1 && $i18n.locale !== 'tw'">Day {{ index + 1 }}</b-col>
          <b-col class="day_title" cols="12" v-if="tour.days > 1 && $i18n.locale === 'tw'">第 {{ index + 1 }} 天</b-col>
          <b-col class="day_content">
            <b-row>
              <!-- 行程介紹 -->
              <b-col class="schedule pt-4" cols="12">
                <!-- 行程介紹title -->
                <h5 class="schedule_title">{{ day.title }}</h5>
                <div class="schedule_info">
                  <div v-html="day.detail" class="spot_txt"></div>
                </div>
              </b-col>
              <!-- 餐廳：改為 3 等分，且文字靠左 -->
              <!-- <b-col class="meals" cols="12">
                <b-row>
                  <b-col v-for="(meal, index) in day.meals" :key="index" cols="12" md="4"
                    class="d-flex flex-column align-items-start">
                    <div v-if="meal.id">
                      <div class="meals_tag mb-0">
                        <b-icon-cup-straw></b-icon-cup-straw>
                        {{ index === 0 ? $t('breakfast') : index === 1 ? $t('lunch') : $t('dinner') }}
                      </div>
                      <SpotCard :spot="meal" class="mb-4"></SpotCard>
                    </div>
                  </b-col>
                </b-row>
              </b-col> -->
              <!-- 餐廳 -->
              <b-col class="meals" cols="12">
                <div v-for="(meal, index) in day.meals" :key="index">
                  <div v-if="meal.id">
                    <div class="meals_tag mb-0">
                      <b-icon-cup-straw></b-icon-cup-straw>
                      {{ index === 0 ? $t('breakfast') : index === 1 ? $t('lunch') : $t('dinner') }}
                    </div>
                    <!-- 將原本用來顯示圖片的 SpotCard 註解掉 -->
                    <!-- <SpotCard :spot="meal" class="mb-4"></SpotCard> -->
                    <!-- 換成顯示文字內容 -->
                    <p>{{ meal.title || meal.text || '無餐廳資訊' }}</p>
                  </div>
                </div>
              </b-col>

              <!-- 景點介紹 -->
              <b-col class="spots" cols="12" v-if="day.spots.length > 0 && day.spots[0].title !== null">
                <div class="spots_tag">
                  <b-icon-geo-alt-fill></b-icon-geo-alt-fill>
                  {{ $t('tourAttractions') }}
                </div>
                <div v-for="(spot, index) in day.spots" :key="index">
                  <SpotCard :spot="spot" class="mb-4"></SpotCard>
                </div>
              </b-col>
              <!-- 高爾夫球場介紹 -->
              <b-col class="spots" cols="12" v-if="day.golf.title !== null">
                <div class="spots_tag">
                  <font-awesome-icon icon="fa-solid fa-golf-ball-tee" />{{ $t('golfAttractions') }}
                </div>
                <SpotCard :spot="day.golf" class="mb-4"></SpotCard>
              </b-col>
              <!-- 飯店名稱 -->
              <b-col class="hotel mb-4" cols="12" v-if="day.hotel.title !== null">
                <div class="hotel_tag">
                  <b-icon-house-fill></b-icon-house-fill>{{ $t('Accommodation') }}
                </div>
                <h5>
                  <a v-if="day.hotel.url" :href="day.hotel.url" target="_blank" rel="noopener">
                    {{ day.hotel.title }}
                  </a>
                  <span v-else>
                    {{ day.hotel.title }}
                  </span>
                </h5>
                <!-- (2024/7改成只放飯店名稱，飯店介紹統一放在下方)<SpotCard :spot="day.hotel" class="mb-4"></SpotCard> -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- 飯店介紹 -->
        <!-- <div v-if="showHotelDetail.length > 0">
          <div class="nav_title">
            <b-icon-house-fill></b-icon-house-fill>
            {{ $t('tourOvernight') }}
          </div>
          <b-row class="day_box">
            <b-col class="hotel" cols="12" v-for="(item, index) in showHotelDetail" :key="index + 'h'">
              <SpotCard :spot="item.hotel" class="mb-4"></SpotCard>
            </b-col>
          </b-row>
        </div> -->
      </div>

      <!-- <div id="photo_part">
          <h6 class="nav_title">映画</h6>
          <b-row class="mt-2">
            <b-col lg="6" class="mb-2">
              <b-embed
              type="video"
              aspect="4by3"
              src="@/assets/video/1.mp4"
              controls
            ></b-embed>
            </b-col>
            <b-col lg="6" class="mb-2">
              <b-embed
              type="video"
              aspect="4by3"
              src="@/assets/video/2.mp4"
              controls
            ></b-embed>
            </b-col>
          </b-row>
        </div> -->
    </div>
  </div>
</template>

<script>
import SpotCard from '@/components/SpotCard.vue'
export default {
  props: {
    tour: {
      type: Object,
      required: true
    },
    schedule: {
      required: true
    },
    // 出團
    registration: {
    }
  },
  components: {
    SpotCard
  },
  data() {
    return {
      showScrollHint: false,
      activeSection: '',
      flightFields: [
        { key: 'airline', label: '航空公司', class: 'td' },
        { key: 'number', label: '航班編號', class: 'td' },
        { key: 'departure', label: '出發時間', class: 'td' },
        { key: 'arrive', label: '抵達時間', class: 'td' },
        { key: 'cities', label: '起抵城市', class: 'td' },
        { key: 'ps', label: '備註', class: 'td' }
      ],
      registr: []
    }
  },
  computed: {
    // 把行程內飯店過濾重複的，用於飯店介紹
    showHotelDetail() {
      // console.log('showHotelDetail')
      const hotelArray = this.schedule.reduce((acc, current) => {
        if (!current.hotel.title || current.hotel.title?.length === 0) {
          return acc
        }
        const x = acc.find(item => item.hotel.title === current.hotel.title)
        if (!x) {
          return acc.concat([current])
        } else {
          return acc
        }
      }, [])
      return hotelArray
    }
  },
  methods: {
    // 檢查不同field要不同顏色
    checkBadgeColor(fieldsData, findex) {
      // console.log(fieldsData)
      if (findex === 0) {
        return 'warning'
      } else if (findex === fieldsData.length - 1 || findex === fieldsData.length - 2) {
        return 'primary'
      } else return 'danger'
    },
    formattedFields(fields) {
      return fields.map(field => ({
        key: field.keyName,
        label: field.label
      }))
    }
  },
  mounted() {
    // 若是小裝置 顯示請左右滑動表格的提示
    if (screen.width < 576) { this.showScrollHint = true }
    // console.log(screen)
  }
}
</script>

<style lang="scss">
#intro_box {
  :target:before {
    content: "";
    display: block;
    height: 50px;
    margin-top: -50px;
  }

  thead {
    color: #fff;
    background-color: var(--myblue);
  }

  #quotaion_part {
    thead {
      color: #fff;
      background-color: #353535;
    }
  }
}

#nav_fixed {
  background-color: #fff;
  border-bottom: 2px solid var(--myblue2);
  border-top: 2px solid var(--myblue2);
  position: sticky;
  top: -1px;
  z-index: 2;

  .nav-item.active a {
    color: #742a2a;
    font-weight: bold;
  }

  a {
    color: var(--myblue);
    font-size: .7rem;
  }

  li {
    list-style: none;
  }

  .nav-bar,
  .container {
    justify-content: start;
  }

  .nav-link {
    padding: .2rem .5rem;
  }

  @media (min-width:440px) {
    a {
      font-size: 1rem;
    }

    .nav-link {
      padding: .3rem .8rem;
    }
  }
}

#intro_part {
  padding: calc(5px + 1vw) 10px 50px;

  th {
    font-weight: 500;
  }

  thead {
    background-color: var(--myblue);
    color: #fff;
  }

  .schedule_tag,
  .spots_tag,
  .meals_tag,
  .hotel_tag {
    color: var(--mytitle);
    font-size: 1rem;
    border-radius: 10px;
    background-color: var(--myblue2);
    display: inline-block;
    padding: .3rem 1rem;
    letter-spacing: 1px;
    font-weight: 500;
    margin: 1rem 0;

    & svg {
      margin-right: 8px;
    }
  }
}

#price_part {
  .price_box {
    justify-content: center;
  }

  .normal_price {
    color: #2a4365;
  }

  .holiday_price {
    color: #742a2a;
  }

  @media (min-width:576px) {
    .price_box {
      justify-content: left;
    }
  }
}

.day_box {
  // 框框
  border-radius: 10px;
  border: 3px solid var(--myblue2);

  hr {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .day_title {
    padding: 7px;
    margin: 3px auto .3rem;
    border-radius: 10px 10px 0 0;
    color: var(--myblue);
    background-color: var(--myblue2);
    position: relative;
    top: -6px;
    letter-spacing: 1px;
    font-size: 1.2rem;
    font-weight: 500;
    text-align: center;
  }

  .schedule,
  .spots,
  .meals,
  .hotel {
    margin: .5rem 0;
  }

  .schedule_title {
    font-weight: bold;
    margin-bottom: 1.4rem;
  }

  .schedule_info {
    & ul {
      padding-left: 1rem;
    }

    & li {
      padding-left: .5rem;
      letter-spacing: .5px;
    }
  }

  .spot_title {
    font-weight: bold;
    letter-spacing: .5px;
    margin-bottom: 1rem;
  }

  .spot_txt {
    letter-spacing: .3px;
    line-height: 1.8rem;
  }

  .spend_time {
    color: var(--mytext);
    font-weight: bold;
  }

  @media (min-width:576px) {
    .day_infoBox {
      margin: 2rem 0;
    }

    .schedule,
    .spots,
    .meals,
    .hotel {
      padding: 0 2rem;
    }
  }
}
</style>
